import { createFileRoute } from "@tanstack/react-router";
import { object, string } from "zod";

import { Account } from "@crm/pages/account";

export const Route = createFileRoute("/(auth)/_headed/clients/$id/account")({
  component: Account,
  validateSearch: object({
    // Deep-links straight into editing this nominee (e.g. from GIFT onboarding).
    edit_nominee: string().optional().catch(undefined),
  }),
});
